export default "__VITE_ASSET__mczAE1bF__"